import React from "react";
import Auth from "../../components/Auth/Auth"

export default function HomePage() {
    return (
        <>
            <Auth />
        </>
    );
}
